import { FC } from 'react';
import { usePOIDescription, usePOILinkPreviewTitle } from '@poi/shared/use-poi-tdk';
import { DynamicHead } from '@lemon8/web-app-shared/ssr';

export const POITDK: FC = () => {
  const title = usePOILinkPreviewTitle();
  const description = usePOIDescription();

  return (
    <DynamicHead>
      <title>{title}</title>
      <meta name="description" content={description} />
    </DynamicHead>
  );
};
